import { render, staticRenderFns } from "./YwfzqkdjForm.vue?vue&type=template&id=4f34a1d4&scoped=true"
import script from "./YwfzqkdjForm.vue?vue&type=script&lang=js"
export * from "./YwfzqkdjForm.vue?vue&type=script&lang=js"
import style0 from "./YwfzqkdjForm.vue?vue&type=style&index=0&id=4f34a1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34a1d4",
  null
  
)

export default component.exports